import React from 'react';

import './NotificationLabel.css';

export default function NotificationLabel({
  isSaving=false,
  hasError=false,
  isSuccessful=false,
  testId='',
  children,
  className=''
}) {
  return (
    <div
      test-id={testId}
      data-testid={testId}
      className={`fade-in-animate notification-label h-40 pa-12-horizontal flex items-center \
        ${isSaving ? 'is-saving' : ''} \
        ${hasError ? 'has-error': ''} \
        ${isSuccessful ? 'is-successful' : ''} \
        ${className}`
      }
    >
      { children }
    </div>
  )
}